<template>
    <div class="history-item rounded-5px overflow-hidden mb-4 border-2 px-5 py-4 last:mb-0" data-cy="container_history_item">
        <div class="flex items-center">
            <div class="flex-none campaign-image w-21 h-21">
                <img :src="purchase.fullImageUrl" data-cy="img_history_item_thumbnail" />
            </div>
            <div class="flex-auto ml-5">
                <div class="text-dark-2 font-medium line-clamp-2 mb-1.5 font-main-medium" data-cy="text_history_item_name">{{ purchase.name }}</div>

                <div class="pointMsg text-dark-6 text-sm mb-1.5" data-cy="text_history_item_point_msg">{{ getPointMessage() }}</div>
                <div v-if="purchase.redeemDate != null" class="text-dark-6 text-sm mb-1.5"
                data-cy="text_history_item_redeemed_on"
                >{{ lbl.customHistory.redeemedOn }} {{ FilterDateTimeFormat(purchase.redeemDate, "dd MMM yyyy - HH:mm") }}</div>

                <div v-if="isExpired" class="expired text-sm text-red-600" data-cy="text_history_item_expired">{{ lbl.customHistory.expired }}</div>
                <div v-if="isUsed" class="expired text-sm text-red-600" data-cy="text_history_item_used">{{ lbl.customHistory.used }}</div>

                <!-- <div v-if="isShowDelivery">{{ deliveryMessage }}</div> -->
                <!-- <div v-if="isShipped">{{ purchase.parcelNo }}</div> -->
                <!-- <div class="privillage" v-if="isShowPrivilegeMessage" v-html="privilegeMessage"></div> -->
            </div>
        </div>
        <template v-if="!isExpired && !isUsed">
            <div class="mt-5">
                <PrimaryButton
                    :btnId="btnRedeemId"
                    :btnMsg="lbl.customHistory.useNow"
                    @onClick="clickPurchase()"
                    data-cy="btn_history_item_use_now"
                ></PrimaryButton>
            </div>
        </template>
    </div>
</template>
<script>
import { getCurrentInstance } from "vue"

import Util from '@/helper/Utility.js';
import { CampaignType } from '@/helper/StaticValue.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import PrimaryButton from '@/components/Button/PrimaryButton.vue';

/**
 * @event onClickPurchase
 */
export default {
    name: 'HistoryItem',
    mixins: [LocaleMixin],
    props: {
        purchase: { type: Object, required: true },
        isShowBtnRedeem: { type: Boolean }
    },
    inject: ["UserLevels"],
    components: {
        PrimaryButton
    },
    data: function () {
        return {
            deliveryMessage: '',
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: '',
            type: 'purchase', //draw, interface, purchase.
            isExpired: false,
            isUsed: false,

        };
    },
    setup: function () {
        const instance = getCurrentInstance()
        return {
            btnRedeemId: instance.vnode.key
        }
    },
    created: function () {
        this.initialPurchase();
    },
    computed: {
        isShowPurchaseMsg: function () {
            return this.type == 'purchase' || this.type == 'draw' || this.type == 'interface';
        },
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.purchase.pointType == 'get' ? this.lbl.history.get_point : this.lbl.history.use_point;
            var pointUnit = this.lbl.history.point + (this.purchase.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.purchase.pointPerUnit + " " + pointUnit;
        },
        initialPurchase: function () {
            if (this.purchase.privilegeMessageFormat && this.purchase.privilegeMessageFormat.toLowerCase() === 'html') {
                this.isShowPrivilegeMessage = false;
            }

            this.isUsed = this.purchase.isUsed; 
            //purchase message.
            switch (this.purchase.type) {
                case CampaignType.Draw:
                    this.isDraw = true;
                    this.type = 'draw';
                    this.purchaseMessage = this.lbl.purchase.not_draw1 + (this.lbl.purchase.not_draw2 ? ' ' + this.lbl.purchase.not_draw2 : '');

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage = this.lbl.purchase.draw_winner1 + (this.lbl.purchase.draw_winner2 ? ' ' + this.lbl.purchase.draw_winner2 : '');

                            if (this.isShowAdsMessage && this.purchase.adsMessage) {
                                this.purchaseMessage += "<br>" + this.purchase.adsMessage;
                            }
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage = this.lbl.purchase.draw_not_win1 + (this.lbl.purchase.draw_not_win2 ? ' ' + this.lbl.purchase.draw_not_win2 : '');
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                case CampaignType.Buy:
                case CampaignType.Free:
                case CampaignType.Deal:
                    if (this.purchase.serial == "XXXXXXX") {
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                        this.isExpired = true
                    } else {
                        this.isActive = true;
                        this.purchaseMessage = this.lbl.purchase.show_code;
                    }
                    break;
                case CampaignType.Interface:
                    this.type = 'interface';
                    if (this.purchase.expireIn && this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                        this.isExpired = true
                        this.isShowPrivilegeMessage = false;
                    } else {
                        if (this.purchase.pointType == "get") {
                            this.purchaseMessage = this.lbl.purchase.interface_get;
                        }
                        else {
                            this.purchaseMessage = this.lbl.purchase.interface_use;
                        }
                    }
                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === CampaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                if (this.purchase.isShipped) {
                    this.isShipped = true;
                    this.deliveryMessage = this.lbl.purchase.shipped;
                } else {
                    this.isShipped = false;
                    this.deliveryMessage = this.lbl.purchase.delivery;
                }
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },

        clickPurchase: function () {
            if (!this.isExpired) {
                /**@type {import("@/helper/TrackingHelper").TrackingService} */
                const trackingService = this.tracking

                if (this.UserLevels.isPlatinum) {
                    trackingService.campaign("my_history_platinum", "click_use_now_platinum", this.purchase, null)
                } else {
                    trackingService.campaign("my_history_gold", "click_use_now_gold", this.purchase, null)
                }

                this.$nextTick(()=>{
                    this.$emit('onClickPurchase', this.purchase);
                })
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/image.scss";
.history-item {
    border-color: #e3e3e3;

    .campaign-image {
        div {
            @include boxRatio(100%);

            background-image: url("~@/assets/imgs/mockup/hungry-nerd-thumbnail.png");
        }
    }
}
</style>
